import {
  ApiCartAddToCartRequestedAction,
  apiCartAddToCartFailed,
  apiCartAddToCartSucceeded
} from '../../../api/cart/addToCartApi';
import addProductToCartAction, {
  AddProductToCartActionResult
} from '@spa/lib/actions/cart/addProductToCartAction';
import { call, put } from 'typed-redux-saga';
import { AddToCurrentCartFailedError } from '../../../carts/CartsState';
import createServerTokenSessionSyncAction from '../../../session/createServerTokenSessionSyncAction';

function* addToCartSaga({
  payload: {
    actionId: requestedActionId,
    customOrderType,
    parentActionId,
    productCode,
    quantity,
    storeCode,
    tracking
  }
}: ApiCartAddToCartRequestedAction): Generator {
  try {
    const actionResult: AddProductToCartActionResult = yield* call(
      addProductToCartAction,
      'addProductToCartAction',
      {
        customOrderType,
        productCode,
        quantity,
        storeCode,
        tracking
      }
    );

    if (actionResult.outcome === 'succeeded') {
      const newTokens = actionResult.result.newTokens;
      if (newTokens !== null) {
        yield* put(createServerTokenSessionSyncAction(newTokens));
      }
      yield* put(
        apiCartAddToCartSucceeded({
          cartId: actionResult.result.cart.code,
          parentActionId,
          productCode,
          quantity,
          requestedActionId,
          result: actionResult.result,
          sourceCustomOrderType: actionResult.sourceCustomOrderType,
          targetCustomOrderType: actionResult.targetCustomOrderType
        })
      );
    } else {
      yield* put(
        apiCartAddToCartFailed({
          parentActionId,
          requestedActionId,
          failedReason: actionResult.failedReason
        })
      );
    }
  } catch {
    yield* put(
      apiCartAddToCartFailed({
        parentActionId,
        requestedActionId,
        failedReason: AddToCurrentCartFailedError.UNKNOWN
      })
    );
  }
}

export default addToCartSaga;
